export default __webpack_public_path__ + "assets/img_webp/twitter.png";